<template>
    <BaseLayout>
        <TransitionEffect>
            <NewPostModal
                v-if="newPostModal"
                @close="newPostModal=false"/>
        </TransitionEffect>

        <TransitionEffect
            v-if="!loading"
            name="simpleFade"
            :appear="true">
            <BlurredBackground
                :image="formattedPosts.leading.cover"/>
        </TransitionEffect>

        <div class="buttons"
            v-if="permissions.isWriter || permissions.isAdmin">
            <Button class="upload"
                appearance="cta"
                size="fullWidth"
                prefixIcon="add_circle"
                @click="newPostModal=true">
                {{ siteContent.newPost }}
            </Button>
            <Button class="drafts"
                appearance="secondary"
                size="fullWidth"
                prefixIcon="edit"
                url="/blog/drafts">
                {{ siteContent.drafts }}
            </Button>
        </div>
        
        <Main>
            <MainContent
                :feed="posts"
                :formattedFeed="formattedPosts"
                :loading="loading"
                :reachedBottom="reachedBottom"
                @handleView="handleView">
                <template slot="leadingItem">
                    <BlurCapImage class="leading"
                        v-if="!loading"
                        :routerLink="'/post/' + formattedPosts.leading.id"
                        :image="formattedPosts.leading.cover"
                        :badgeLabel="siteContent.recentlyPublished"
                        badgeType="recent">
                        <LeadingPost
                            :post="formattedPosts.leading"/>
                    </BlurCapImage>
                </template>
                <template slot="feed">
                    <PostFeed
                        v-if="!loading"
                        :posts="formattedPosts.regular"/>
                </template>
            </MainContent>
        </Main>
    </BaseLayout>
</template>

<script>
    import { mapActions, mapState } from 'vuex'

    import BaseLayout   from '@/components/layout/main/BaseLayout'
    import NewPostModal from '@/components/blog/main/NewPostModal'
    import Main         from '@/components/layout/main/Main'
    import MainContent  from '@/components/layout/main/MainContent'
    import LeadingPost  from '@/components/blog/main/LeadingPost'
    import PostFeed     from '@/components/blog/main/PostFeed'

    export default {
        name: 'Blog',
        components: {
            BaseLayout,
            NewPostModal,
            Main,
            MainContent,
            LeadingPost,
            PostFeed
        },
        data() {
            return {
                loading: true,
                newPostModal: false,
            }
        },
        computed: {
            ...mapState('blog',['posts','reachedBottom']),

            formattedPosts() {
                var regularPosts = this.posts.slice(1, this.posts.length)
                var leadingPost = this.posts[0]

                var posts = {
                    regular: regularPosts,
                    leading: leadingPost
                }
                
                return posts
            },
            lastVisible() {
                return this.posts[this.posts.length - 1]
            }
        },
        async mounted() {
            if(this.posts.length === 0) {
                this.loadFeed()
            } else {
                this.loading = false
            }
        },
        methods: {
            ...mapActions('blog',['fetchPosts','fetchPostsAfter','setReachedBottomToDefault']),

            async loadFeed() {
                try {
                    this.setReachedBottomToDefault()
                    await this.fetchPosts({
                        visibility: true,
                        commitName: 'setBlogPosts',
                        limit: 3
                    })
                    this.loading = false
                } catch(e) {
                    throw e
                }
            },
            async handleView() {
                await this.fetchPostsAfter({
                    visibility: true,
                    commitName: 'addBlogPosts',
                    lastVisible: this.lastVisible,
                    limit: 2
                })
            }
        },
        metaInfo() {
            if(this.preferences.language === 'hu') {
                return {
                    title: 'Blog | Creatillo',
                    meta: [
                        { vmid: 'description', name: 'description', content: 'Tanulj a digitális festészetről, fotózásról, történetírásról, és sok másról, miközben bepillantást nyersz, ahogyan egy csodálatos univerzumot alkotunk.' },
                        { vmid: 'keywords', name: 'keywords', content: 'digital painting, digital painting ideas, universe art, space art' }
                    ]
                }
            } else {
                return {
                    title: 'Blog | Creatillo',
                    meta: [
                        { vmid: 'description', name: 'description', content: 'Learn more about digital painting, photography, storytelling and more while getting a sneak-peak into how we are creating a wonderful universe.' },
                        { vmid: 'keywords', name: 'keywords', content: 'digital painting, digital painting ideas, universe art, space art' }
                    ]
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../scss/variables';

    .buttons {
        display: flex;
        align-self: center;
        width: 100%;
        margin-bottom: 2rem;
        max-width: 28rem;
    }

    .upload {
        margin-right: 1rem;
    }
</style>